export default __webpack_public_path__ + "static/media/slide1-app.14eef425.png";